import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    paddingTop: 24,
    paddingBottom: 24,
    paddingLeft: 30,
    paddingRight: 30,
    fontFamily: 'Helvetica',
    fontSize: 9.5,
    color: '#000000',
    lineHeight: 1.3,
  },
  header: {
    marginBottom: 8,
    textAlign: 'center',
  },
  name: {
    fontSize: 18,
    fontFamily: 'Helvetica-Bold',
    color: '#000000',
    marginBottom: 4,
    textTransform: 'uppercase',
    lineHeight: 1.2,
  },
  title: {
    fontSize: 12,
    color: '#333333',
    marginBottom: 6,
    lineHeight: 1.2,
  },
  contactItem: {
    fontSize: 8.5,
    color: '#555555',
  },
  contactRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: 5,
  },
  link: {
    color: '#0055cc',
    textDecoration: 'none',
  },
  section: {
    marginBottom: 8,
  },
  sectionTitle: {
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    color: '#000000',
    textTransform: 'uppercase',
    marginBottom: 2,
  },
  sectionUnderline: {
    borderBottomWidth: 0.5,
    borderBottomColor: '#000000',
    marginBottom: 4,
  },
  summaryText: {
    textAlign: 'justify',
  },
  skillsRow: {
    flexDirection: 'row',
    marginBottom: 4,
  },
  skillCategory: {
    fontFamily: 'Helvetica-Bold',
    width: '30%',
    paddingRight: 12,
  },
  skillItems: {
    width: '70%',
  },
  experienceItem: {
    marginBottom: 6,
  },
  experienceHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginBottom: 1,
  },
  jobTitle: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 10,
  },
  companyName: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 10,
  },
  jobMeta: {
    fontFamily: 'Helvetica-Oblique',
    fontSize: 8.5,
    marginBottom: 3,
  },
  bulletRow: {
    flexDirection: 'row',
    marginBottom: 2,
    paddingLeft: 8,
    paddingRight: 4,
  },
  bulletPoint: {
    width: 8,
    fontSize: 9.5,
  },
  bulletText: {
    flex: 1,
    textAlign: 'justify',
  },
  projectItem: {
    marginBottom: 6,
  },
  projectHeader: {
    flexDirection: 'row',
    alignItems: 'baseline',
    marginBottom: 1,
  },
  projectName: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 10,
  },
  projectDesc: {
    fontFamily: 'Helvetica',
    fontSize: 10,
  },
  educationItem: {
    marginBottom: 3,
  },
  educationHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  educationInstitution: {
    fontFamily: 'Helvetica',
  },
  educationDegree: {
    fontFamily: 'Helvetica-Bold',
  },
  educationDate: {
    fontFamily: 'Helvetica-Oblique',
  },
});
